import { useState, useCallback } from 'react';
import { postCloneSelectedNotesURL } from "../../utils/ConstantsURL";

export const useFlexibleClone = () => {
    const [loadingFlex, setLoadingFlex] = useState(false);

    const executeFlexibleClone = useCallback(async (token, params) => {
        if (loadingFlex) return { success: false, error: "Operación en curso, por favor espere." };

        setLoadingFlex(true);
        try {
            const fullUrl = postCloneSelectedNotesURL();
            
            const payload = {
                originDocumentId: Number(params.originDocumentId),
                originSectionId: Number(params.originSectionId),
                targetDocumentId: Number(params.targetDocumentId),
                targetSectionId: Number(params.targetSectionId),
                noteIds: Array.isArray(params.items) ? params.items.map(Number) : [],
                date: params.date
            };

            console.log("Enviando Payload a Backend (IDs de Síntesis):", payload);

            const response = await fetch(fullUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            const contentType = response.headers.get("content-type");
            let data = {};
            
            if (contentType && contentType.includes("application/json")) {
                data = await response.json();
            }

            if (!response.ok) {
                throw new Error(data.error || data.message || `Error del servidor: ${response.status}`);
            }

            if (data.details && data.details[0]?.success === false) {
                throw new Error(data.details[0].error || "El servidor no encontró las notas solicitadas.");
            }

            return { success: true, data };

        } catch (err) {
            console.error("Error en useFlexibleClone:", err.message);
            return { success: false, error: err.message };
        } finally {
            setLoadingFlex(false);
        }
    }, [loadingFlex]);

    return { executeFlexibleClone, loadingFlex };
};